import { Col, Row, Typography } from 'antd'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { DocumentAttachmentIcon, DocumentValidationIcon, MessageQuestionIcon } from 'hugeicons-react'

function Shortcut() {
    const { Title } = Typography;

    return (
        <Row className="shortcut-list" gutter={[16, 16]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={8} >
                <NavLink to="/student-questions" >
                    <div className='shortcut-item shortcut-item--question'>
                        <Row justify={"center"} align={"middle"}>
                            <MessageQuestionIcon className="shortcut-item__icon" size={60} />
                        </Row>
                        <Row justify={"center"} align={"middle"}>
                            <Title className='shortcut-item__title' level={5}>Soru Sor</Title>
                        </Row>
                    </div>
                </NavLink>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={8} >
                <NavLink to="/quizzes" >
                    <div className='shortcut-item shortcut-item--quiz'>
                        <Row justify={"center"} align={"middle"}>
                            <DocumentValidationIcon className="shortcut-item__icon" size={60} />
                        </Row>
                        <Row justify={"center"} align={"middle"}>
                            <Title className='shortcut-item__title' level={5}>Sınav</Title>
                        </Row>
                    </div>
                </NavLink>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={8} >
                <NavLink to="/exams" >
                    <div className='shortcut-item shortcut-item--assignment'>
                        <Row justify={"center"} align={"middle"}>
                            <DocumentAttachmentIcon className="shortcut-item__icon" size={60} />
                        </Row>
                        <Row justify={"center"} align={"middle"}>
                            <Title className='shortcut-item__title' level={5}>Ödev</Title>
                        </Row>
                    </div>
                </NavLink>
            </Col>
        </Row >
    )
}

export default Shortcut
